import { useRef } from 'react';

import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';
import { downloadCard } from '#client/pages/EducationStudio/utils/downloadCard';

import { useLessonStorage } from '../../../../hooks';
import SummaryCard from '../../../Interactive/Peaks/FindYourIkigaiSummaryCard/index';
import { ExercisePage } from '../../../Interactive/WorksheetActivity/exercisePage';

const StyledContainer = styled('div')(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: '31.25rem'
  }
}));

const SummaryCardContainer = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('md')]: {
    maxWidth: '31.25rem'
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  padding: '1rem 0',
  textTransform: 'none',
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

const StyledText = styled(Text)(({ theme }) => ({
  marginBottom: '2rem !important',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '1.5rem !important'
  }
}));

const StyledNextButton = styled(Button)(({ theme }) => ({
  padding: '1.25rem 2rem',
  textTransform: 'none',
  marginBottom: '1rem',
  [theme.breakpoints.down('sm')]: {
    padding: '1.25rem 0',
    width: '100%'
  }
}));

const PeaksSummaryPage = ({ onPrimaryClick }) => {
  const { lesson } = useParams();
  const { getStorageValue } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const cardRef = useRef();

  const presentation = (
    <>
      <StyledContainer
        ref={cardRef}
      >
        <SummaryCard
          bgColor="focus10"
          summary={getStorageValue('myIkigaiIs')}
        />
      </StyledContainer>
      <SummaryCardContainer>
        <StyledButton
          variant="outlined"
          size="large"
          color="primary"
          onClick={() => downloadCard(cardRef.current, 'your_ikigai.png')}
        >
          Download
        </StyledButton>
      </SummaryCardContainer>
    </>
  );

  const summary = (
    <>
      <Text size="lg" bold>
        Write this down!
      </Text>
      <StyledText size="lg">
        {
          ' Keep this statement in mind when working through your business decisions. It’ll help make sure you’re always staying true to your business purpose.'
        }
      </StyledText>
    </>
  );

  return (
    <ExercisePage
      caption="Summary"
      title="Your Ikigai ✨"
      summary={summary}
      presentation={presentation}
      buttonText="Continue"
      onNext={onPrimaryClick}
    >
      {!isMobile && (
      <StyledNextButton
        variant="contained"
        color="primary"
        size="large"
        onClick={onPrimaryClick}
      >
        Continue
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

PeaksSummaryPage.propTypes = {
  onPrimaryClick: PropTypes.func
};

export default PeaksSummaryPage;
